import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { MY_DASHBOARD_QUERY } from "graphql/mydashboard";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for financial service
let myDashboardClient = null;

/**
 * Initialize Apollo Client for financial service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
const getDashboardClient = () => {
  if (myDashboardClient) {
    return myDashboardClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  myDashboardClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return myDashboardClient;
};

export async function fetchMyDashboard(
  timePeriod = "YTD",
  highlightsTimePeriod = "YTD",
  filters = {}
) {

  try {

    const client = getDashboardClient();

    const { data } = await client.query({
      query: MY_DASHBOARD_QUERY,
      variables: {
        timePeriod,
        highlightsTimePeriod,
        netSalesFilter: filters,
        salesFilter: filters,
        salesFilterWithSubBrand: filters
      },
      fetchPolicy: "network-only"
    });

    return data;

  } catch (error) {
    console.error(error);
    throw error;
  }
}
